import {
  MatchStatusEnum,
  Select,
  Textarea,
  TransactionWarningActionEnum,
} from '@ui/src';
import { OngoingMonitroingPanelPopupContentTypes } from './types';

import cn from './styles.module.css';

const OngoingMonitroingPanelPopup = ({
  matchStatus,
  setMatchStatus,
  batchApplyDisabled,
  batchApplyWarningInProgress,
  action,
  setAction,
  aproveAllowed,
  rejectAllowed,
  comment,
  setComment,
}: OngoingMonitroingPanelPopupContentTypes) => (
  <div className={cn.applyAllContent}>
    <Select
      name="matchStatus"
      value={matchStatus}
      onChange={(e) => setMatchStatus(e.target.value as string)}
      list={[
        {
          name: 'False',
          value: MatchStatusEnum.FALSE,
        },
        {
          name: 'True',
          value: MatchStatusEnum.TRUE,
        },
        {
          name: 'Potential',
          value: MatchStatusEnum.POTENTIAL,
        },
      ]}
      placeholder="Select Match status"
      disabled={batchApplyDisabled || batchApplyWarningInProgress}
      className={cn.matchStatusSelect}
      fullWidth
    />
    <Select
      name="actions"
      value={action}
      onChange={(e) => setAction(e.target.value as string)}
      list={[
        {
          name: 'Pass all time for this client',
          value: TransactionWarningActionEnum.PASS_ALL_TIME_FOR_THIS_CLIENT,
          hidden: !aproveAllowed,
        },
        {
          name: 'Pass combination',
          value: TransactionWarningActionEnum.PASS_COMBINATION,
          hidden: !aproveAllowed,
        },
        {
          name: 'Pass once',
          value: TransactionWarningActionEnum.PASS_ONCE,
          hidden: !aproveAllowed,
        },
        {
          name: 'Stop',
          value: TransactionWarningActionEnum.STOP,
          hidden: !rejectAllowed,
        },
      ]}
      placeholder="Select actions"
      className={cn.matchStatusSelect}
      disabled={batchApplyDisabled || batchApplyWarningInProgress}
      fullWidth
    />
    <Textarea
      name="comment"
      value={comment}
      onChange={(e) => setComment(e.target.value)}
      placeholder="Enter a comment..."
      disabled={batchApplyDisabled || batchApplyWarningInProgress}
    />
  </div>
);

export default OngoingMonitroingPanelPopup;
